import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DocumentSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DocumentSVG;
